export default "__VITE_ASSET__DxCXkWtH__"